import React, { useState } from "react";
import { Popup } from 'witmeg-ui-system';
import "./Modal.scss"
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";




const ModalOpt = ({ visibility, onPopupClose, emailChecked, setEmailChecked, smsChecked, setSMSChecked, whatsappChecked, setWhatsappChecked,
}) => {
    const [isEmail, setIsEmail] = useState(false)
    const [isSMS, setIsSMS] = useState(false)
    const [isWA, setIsWA] = useState(false)
    const [showErrow, setShowError] = useState(false)
    return (
        <Popup
            className='Modal-Menu'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            closable={false}>
            <div className="modal-inner">
                <div className="modal-header-text2">Choose how you'd like to receive offers:</div>
                <div className="modal-optcont">
                    <CustomCheckbox
                        checked={isEmail}
                        onChange={() => {
                            setIsEmail(!isEmail)
                            setShowError(false)
                        }} />

                    <div className="modal-optcont-text">
                        <div className="modal-optcont-text-header">Email</div>
                        <div className="modal-optcont-text-subheader">Weekly deals and personalized offers</div>
                    </div>
                </div>
                <div className="modal-optcont">
                    <CustomCheckbox
                        checked={isSMS}
                        onChange={() => {
                            setIsSMS(!isSMS)
                            setShowError(false)

                        }} />
                    <div className="modal-optcont-text">
                        <div className="modal-optcont-text-header">SMS</div>
                        <div className="modal-optcont-text-subheader">Flash sales and urgent updates</div>
                    </div>
                </div>
                <div className="modal-optcont">
                    <CustomCheckbox
                        checked={isWA}
                        onChange={() => {
                            setIsWA(!isWA)
                            setShowError(false)

                        }} />
                    <div className="modal-optcont-text">
                        <div className="modal-optcont-text-header">WhatsApp</div>
                        <div className="modal-optcont-text-subheader">Order updates and exclusive tips</div>
                    </div></div>
                <div className="btn-container" onClick={() => {
                    if (!isEmail && !isSMS && !isWA) {
                        setShowError(true)
                    } else {
                        setEmailChecked(isEmail)
                        setSMSChecked(isSMS)
                        setWhatsappChecked(isWA)
                        onPopupClose()
                        setIsEmail(false)
                        setIsSMS(false)
                        setIsWA(false)
                    }

                }}>OK</div>
                {showErrow && <div className="modal-error-text">*Please select one method</div>}

            </div>
        </Popup >
    )
}
export default ModalOpt